var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNsgShaper = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 1056 1056"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "NSG_SHAPER_svg__a",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 792h792V0H0Z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#NSG_SHAPER_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 1056)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 0 4.945 4.944L24.44 24.439l46.797 46.797L171.71 171.709l-70.332 70.331-3.937-3.936L83.3 223.961l-14.143 14.143-24.212 24.212-5.722-5.722-.531-.531-5.588-5.589 24.211-24.212 14.143-14.142-14.143-14.142-2.689-2.69 44.615-42.629L-33.178 16.703a401 401 0 0 1 11.431-6.343C-14.033 6.247-6.868 2.719 0 0",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(550.986 236.265)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-65.193 67.536V15.542l63.574-63.574 95.12 95.119c-9.835 6.592-19.254 13.294-28.222 19.936Z",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(387.982 119.674)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-47.361 49.063 62.507 60.26c-13.648 17.989-27.53 37.46-40.812 58.526l-99.736-99.737L-57.29 0h18.35z",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(175.434 339.861)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h-59.487v119.181h59.42l-59.42-59.695zl58.53 60.002V0Zm30.246 60.002L0 28.284l-31.203 31.202 31.136 31.41ZM-.067 119.181H58.53V60.002Zm73.536 31.521-8.068-8.067H-84.312V-23.661H81.984v149.71l7.862 7.862a1367 1367 0 0 0-16.377 16.791",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(220.805 177.227)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-15.317 15.227-30.869 30.13-46.582 44.742-12.484 11.609-25.387 22.624-38.503 33.298l-8.244-7.946a497 497 0 0 0 16.524-13.683c23.685-20.497 47.302-41.254 70.1-63.116z",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(435.639 497.579)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-26.562 34.543-53.925 68.45-82.883 100.162-2.126 2.328-4.277 4.628-6.417 6.939l-6.384-6.383c33.017-35.731 63.773-74.07 90.261-116.89l9.952 10.22A825 825 0 0 1 0 0",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(569.035 344.836)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0c-7.279 17.636-15.667 34.432-24.868 50.569L-43.03 32.406c.925-3.639 1.72-7.346 2.335-11.151 3.801-23.545-5.562-36.475-25.996-35.523-14.108.657-27.383 5.091-40.287 11.012a226 226 0 0 0-3.959 1.865 277 277 0 0 0-3.968 1.958 350 350 0 0 0-3.394 1.737q-.248.128-.495.256a404.314 404.314 0 0 0-12.121 6.567l-.211.121a450 450 0 0 0-8.122 4.695c-36.481 21.597-70.23 48.538-102.829 77.612a1147 1147 0 0 0-43.971 41.326v.001a1069 1069 0 0 0-8.173 8.186l-.202.205q-4.071 4.125-8.104 8.298c-29.182 30.212-56.82 62.409-82.518 97.062-6.203 8.363-12.309 16.816-18.216 25.433a576 576 0 0 0-4.709 6.982l-.703 1.061a486 486 0 0 0-6.933 10.795l-.572.922a395 395 0 0 0-11.372 19.531 341 341 0 0 0-6.439 12.458 309 309 0 0 0-5.882 12.698 290 290 0 0 0-4.804 11.65c-3.13 8.134-5.512 16.821-7.192 25.519-4.322 22.38 4.446 35.265 27.586 35.876 7.641-.154 15.758-2.096 24.092-5.078l16.179 16.18c-19.85 12.343-40.34 23.203-61.733 31.863-16.469 6.666-33.22 11.866-50.771 10.968-22.305-1.142-33.245-16.213-31.133-42.491.12-1.488.302-2.973.494-4.452 2.731-21.087 10.267-40.106 18.956-58.567 10.504-22.318 22.398-43.399 35.241-63.625.602-.948 1.201-1.898 1.807-2.843a731.51 731.51 0 0 1 5.336-8.178 703 703 0 0 1 3.7-5.544q.695-1.026 1.394-2.049a849 849 0 0 1 19.387-27.309l.569-.77c9.61-12.976 19.506-25.69 29.584-38.231a1362 1362 0 0 1 91.413-102.724c33.975-34.48 69.507-66.81 106.579-96.973 14.358-11.681 28.89-23.014 43.697-33.765 1.152-.836 2.302-1.678 3.457-2.506a683 683 0 0 1 5.589-3.96c.515-.361 1.028-.728 1.544-1.087a668 668 0 0 1 6.545-4.516q.23-.157.461-.315a630 630 0 0 1 7.038-4.721v-.001C-123.758-55.09-102-67.63-79.259-78.013c19.246-8.786 38.821-16.15 54.919-16.205 30.902.639 43.248 16.787 38.26 47.124C11.265-30.945 6.147-14.893 0 0",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(641.73 223.286)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-27.532-27.532c9.484-23.743 22.199-45.491 35.88-65.738l18.034 17.386L142.29 35.859l96.943-92.628 49.44 49.439-148.002 148.001-95.722-95.722Z",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(245.692 603.634)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 0-46.957-46.957A1051 1051 0 0 1-30.47-63.639l48.12 48.12 8.742 8.742 32.033 32.033 6.397 6.397 14.233 14.233L129.131-4.19l20.256 20.254L172.44-6.99l17.49 17.489 3.011 3.011-38.354 38.355 19.73 19.731.265.264.265.265 6.622 6.622 13.244 13.244 38.354-38.354 20.5 20.5-23.054 23.054 20.3 20.301-50.077 50.076 19.146 19.145-16.584 16.584L8.741 8.741Z",
  style: {
    fill: "#4cb148",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none"
  },
  transform: "translate(401.219 434.874)"
})));
export default SvgNsgShaper;